import { Policy } from '@/modules/core/app/models/policies/Policy';

export class EntityPolicyResult {
  canDelete?: Policy;

  canEdit?: Policy;

  constructor(policies: Partial<EntityPolicyResult> = {}) {
    this.canDelete = new Policy(policies.canDelete);
    this.canEdit = new Policy(policies.canEdit);
  }
}
